import HttpClient from "../clients/HttpClient";

export default class VitecService {
  static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

  public static async sync(account_id): Promise<void> {
    await this.httpClient.post("/vitec/sync", {'account_id': account_id});
  }
}

